import React from 'react';
import { FormattedRelativeTime } from 'react-intl-next';
import { selectUnit } from '@formatjs/intl-utils';
import { extractDateCreated, extractDateUpdated, extractPersonCreatedBy, extractPersonUpdatedBy } from '@atlaskit/link-extractors';
export const extractByline = jsonLd => {
  const updatedAt = extractDateUpdated(jsonLd);
  const createdAt = extractDateCreated(jsonLd);
  if (updatedAt) {
    const {
      value,
      unit
    } = selectUnit(new Date(updatedAt).getTime());
    const updatedBy = extractPersonUpdatedBy(jsonLd);
    return /*#__PURE__*/React.createElement("span", null, "Updated ", updatedBy && `by ${updatedBy.name}`, ' ', /*#__PURE__*/React.createElement(FormattedRelativeTime, {
      value: value,
      unit: unit
    }));
  } else if (createdAt) {
    const {
      value,
      unit
    } = selectUnit(new Date(createdAt).getTime());
    const createdBy = extractPersonCreatedBy(jsonLd);
    const createdByPerson = extractFirstPerson(createdBy);
    return /*#__PURE__*/React.createElement("span", null, "Created ", createdByPerson && `by ${createdByPerson.name}`, ' ', /*#__PURE__*/React.createElement(FormattedRelativeTime, {
      value: value,
      unit: unit
    }));
  }
};
const extractFirstPerson = persons => {
  if (persons && persons.length > 0) {
    return persons.shift();
  }
};